/* 🤖 this file was generated by svg-to-ts */
export const matIconDriveFileMoveRtl: {
  name: 'drive-file-move-rtl';
  data: string;
} = {
  name: 'drive-file-move-rtl',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.59-2.41L12 17l-4-4 4-4 1.41 1.41L11.83 12H16v2h-4.17l1.58 1.59z"/></svg>`
};
